<script lang="ts" setup>
import { useRouter } from 'vue-router';

const router = useRouter();

const navigate = (path: string) => {
  router.push(path);
};
</script>

<template>
  <v-container class="pt-16 card-list">
    <v-card
      class="mb-8 bg-primary card"
      @click="navigate('/statistics/quizzes')"
    >
      <v-card-text>
        <h2>Quiz Of The Day</h2>
        <p>
          Number of quiz <i>started</i> versus <i>finished</i> over the last 30
          days per category
        </p>
      </v-card-text>
    </v-card>
    <v-card
      class="mb-8 bg-primary card"
      @click="navigate('/statistics/actions')"
    >
      <v-card-text>
        <h2>Actions</h2>
        <p>Number of actions added, completed per day</p>
      </v-card-text>
    </v-card>
    <v-card
      class="mb-8 bg-primary card"
      @click="navigate('/statistics/co2-scan')"
    >
      <v-card-text>
        <h2>CO₂ Footprint scans</h2>
        <p>User counts per footprint</p>
      </v-card-text>
    </v-card>
    <v-card
      class="mb-8 bg-primary card"
      @click="navigate('/statistics/user-interests')"
    >
      <v-card-text>
        <h2>Users</h2>
        <p>User statistics</p>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<style scoped>
.card-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.card {
  width: calc(50% - 32px);
  min-height: 120px;
  margin: 16px;
}
</style>
